import { activeSiteConfig } from "@config/site/site-config";

const {
    geo: { imperialMetricSystem },
} = activeSiteConfig;

export const calculateZoomLevel = (distance: number) => {
    return Math.round(Math.log2(80000 / (imperialMetricSystem ? distance / 0.621371 : distance)));
};
